<template>
	<div id="menu-principal" class="flex flex-col items-start">
		<div
			v-if="routeActive(`/empresas/${empresaPk}/`)"
			class="empresa flex items-center mb-4"
		>
			<h2 class="empresa-title">
				{{ empresa ? empresa.nome : "" }}
			</h2>
		</div>

		<div class="flex">

			<ul class="flex">
				<li
					v-if="$permissions.can('autenticadosuperuser') || $permissions.can('empresavisualizar')"
					:class="{
						active: routeActive(
							null,
							'/empresas',
						)
					}"
					class="menu-item cursor-pointer mr-2"
					@click="navigateTo('/empresas')"
				>
					<feather-icon
						icon="BriefcaseIcon"
						svgClasses="custom-icon"
					></feather-icon>
				</li>

				<li
					v-if="empresaPk && ($permissions.can('colaboradoradicionar') || $permissions.can('autenticadosuperuser'))"
					:class="{
						active: routeActive(null, null, [
							`/empresas/${empresaPk}/usuarios`
						])
					}"
					class="menu-item cursor-pointer mr-2"
					@click="navigateToUsers()"
				>
					<feather-icon
						icon="UsersIcon"
						svgClasses="custom-icon"
					></feather-icon>
					<!-- <font-awesome-icon :icon="faUserCircle" class="custom-icon" /> -->
				</li>

				<li
					v-if="!empresaPk && $permissions.can('autenticadosuperuser')"
					:class="{
						active: routeActive(null, null, [
							'/usuarios'
						])
					}"
					class="menu-item cursor-pointer mr-2"
					@click="navigateToUsers()"
				>
					<!-- <font-awesome-icon :icon="faUserCircle" class="custom-icon" /> -->
					<feather-icon
						icon="UsersIcon"
						svgClasses="custom-icon"
					></feather-icon>
				</li>

				<li
					v-if="empresaPk && ($permissions.can('prazovisualizar') || $permissions.can('autenticadosuperuser'))"
					:class="{
						active: routeActive(null, `/empresas/${empresaPk}/prazos`)
					}"
					class="menu-item cursor-pointer mr-2"
					@click="navigateTo(`/empresas/${empresaPk}/prazos`)"
				>
					<font-awesome-icon :icon="faCalendarAlt" class="custom-icon" />
				</li>

				<li
					v-if="empresaPk && ($permissions.can('prazovisualizar') || $permissions.can('autenticadosuperuser'))"
					:class="{
						active: routeActive(null, `/empresas/${empresaPk}/prazos/listar`)
					}"
					class="menu-item cursor-pointer mr-2"
					@click="navigateTo(`/empresas/${empresaPk}/prazos/listar`)"
				>
					<font-awesome-icon :icon="faFileAlt" class="custom-icon" />
				</li>
			</ul>
			<notification v-if="empresaPk && $permissions.can('notificacaovisualizar') && temColaborador"/>
		</div>
	</div>
</template>

<script>
import {
	faUserCircle,
	faCalendarAlt,
	faBell,
	faFileAlt
} from "@fortawesome/free-regular-svg-icons";

import Colaborador from '../../models/Colaborador';
import Notification from '../notification/Notification';

export default {
	data() {
		return {
			faUserCircle,
			faCalendarAlt,
			faBell,
			faFileAlt
		};
	},
	components: {
		Notification
	},
	computed: {
		empresa() {
			if (this.routeActive(`/empresas/${this.empresaPk}/`)) {
				return this.$DAO.user.getProperty("empresa");
			}
			return null;
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		temColaborador() {
			return Colaborador.hasColaborador();
		},
		route() {
			return this.$route.path;
		},
	},
	methods: {
		navigateToUsers() {
			let path = this.route;

			if (this.route == "/empresas") {
				path = "/usuarios";
			} else {
				path = `/empresas/${this.empresaPk}/usuarios`;
			}

			if (this.route !== path) {-
				this.$router.push({ path });
			}
		},
		navigateTo(path) {
			if (this.route !== path) {
				this.$router.push({ path });
			}
		},
		routeActive(startPath, endPath, pathsActive = [], pathsDeactivate = []) {
			if (pathsActive.includes(this.route)) {
				return true;
			}

			if (pathsDeactivate.includes(this.route)) {
				return false;
			}

			if (endPath) {
				return this.route.endsWith(endPath);
			}

			if (startPath) {
				return this.route.startsWith(startPath);
			}

		}
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/_variables.scss";

#menu-principal {
	.empresa {
		transition: all 0.5s ease;

		&-title {
			padding: 0 0.4rem;
			font-size: 20px;
			color: #626262;

			&__divider {
				font-size: 20px;
				color: #ababab;
			}
		}
	}

	.menu-item {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 0.5rem;
		padding: 7px;

		&.active {
			background: $primary;

			.menu-title,
			.custom-icon {
				color: $white;
			}
		}

		&:not(.active):hover {
			background: rgba($grey, 0.2);
		}

		&.active {
			.menu-title {
				opacity: 1;
				position: relative;
			}
		}

		.custom-icon {
			width: 24px !important;
			height: 24px !important;
		}

		.menu-title {
			position: absolute;
			right: 0;
			opacity: 0;
			margin-left: 4px;
			font-size: 1.1rem;
			color: #626262;
		}
	}

	@media (max-width: 1000px) {
		order: 2;
		width: 100%;
		margin-top: 25px;
	}

	@media (max-width: 500px) {
		.empresa .empresa-title {
			font-size: 17px;
		}
	}
}
</style>
